import React from 'react';
import { useHistory } from 'react-router';
import { RefreshIcon } from 'AppSrc/core/components/common/svg-icons';
import 'AppSrc/core/style/components/utility/back-refresh.scss';

const BackAndRefresh = () => {
  const history = useHistory();

  // refresh current page
  const refreshPage = () => {
    window.location.reload();
  };

  // Svg Component For Left back arrow
  const LeftBackArrowSvg = () => (
    <svg viewBox="0 0 20 18">
      <g fill="none" fillRule="evenodd">
        <path
          d="M24 12.001H2.914l5.294-5.295-.707-.707L1 12.501l6.5 6.5.707-.707-5.293-5.293H24v-1z"
          fill="currentColor"
        />
      </g>
    </svg>
  );

  return (
    <>
      <div className="outer-back-refr-wrap">
        <div className="back-btn-inner">
          <button
            type="button"
            title="Go Back"
            onClick={() => history.goBack()}
          >
            <LeftBackArrowSvg />
          </button>
        </div>
        <div className="rfr-btn-inner">
          <button type="button" title="Refresh Page" onClick={refreshPage}>
            <RefreshIcon />
          </button>
        </div>
      </div>
    </>
  );
};

export { BackAndRefresh };
